import { createTheme } from '@mui/material'

const themeOptions = {
	palette: {
		type: 'light',
		primary: {
            main: '#28354d',
			light: '#525f79',
			dark: '#000e25',
			contrastText: "#ffffff" //button text white instead of black
		},
		secondary: {
            main: '#c41215',
			light: '#ff523e',
			dark: '#8b0000',
			contrastText: "#ffffff"
		},
		background: {
			main: '#f5f5f5',
			dark: '#28354d',
			danger: '#ffcdd2',
		},
	},
    typography: {
        fontFamily: `'Inter', sans-serif`,
    },
	overrides: {
		MuiGrid: {
			container: {
				width: '100% !important',
				margin: '0 !important',
			},
		},
	},
}

export const Theme = createTheme(themeOptions)